export { default } from "./RelatedFunctions";
